import { z } from 'zod';
import { PipelineStepSchema } from './execution-schemas.js';
export const ProjectValidatorInputSchema = z.object({
    sessionId: z.string().describe('Session ID for execution tracking'),
    validationType: z.enum(['lint', 'test', 'build', 'all']).optional().default('all').describe('Type of validation'),
    projectPath: z.string().optional().describe('Path to the project to validate (defaults to current directory)'),
    verbose: z.boolean().optional().default(false).describe('Enable verbose output'),
});
export const ProjectAnalyzerInputSchema = z.object({
    sessionId: z.string().describe('Session ID for execution tracking'),
    projectIdentifier: z.string().describe('Project name or relative path to analyze'),
    includeFileStructure: z.boolean().optional().default(false).describe('Include detailed file structure analysis'),
    basePath: z.string().optional().default('/Users/raajkumars/Projects/qwickapps').describe('Base path for project search'),
});
export const ContextAnalyzerInputSchema = z.object({
    sessionId: z.string().describe('Session ID for execution tracking'),
    projectPath: z.string().optional().default('/Users/raajkumars/Projects/qwickapps').describe('Path to the project directory'),
});
export const AgentListerInputSchema = z.object({
    sessionId: z.string().describe('Session ID for execution tracking')
});
export const ConfigValidatorInputSchema = z.object({
    sessionId: z.string().describe('Session ID for execution tracking'),
    agentName: z.string().optional().default('all').describe('Agent to validate')
});
export const PipelineOrchestratorInputSchema = z.object({
    sessionId: z.string().uuid().describe('Session identifier for tracking'),
    pipeline: z.array(PipelineStepSchema).min(1).describe('Array of pipeline steps'),
    globalContext: z.record(z.any()).optional().describe('Global context variables available to all steps')
});
export const AgentExecutorInputSchema = z.object({
    sessionId: z.string().uuid().describe('Session identifier for tracking'),
    agentName: z.enum([
        'architect',
        'coder',
        'reviewer',
        'quality-engineer',
        'tech-writer',
        'devops',
        'tech-lead',
        'engineering-manager',
        'product-manager',
        'summarizer',
    ]).describe('Name of the agent to execute (architect, coder, reviewer, etc.)'),
    prompt: z.string().min(1).describe('The prompt/task for the agent'),
    projectName: z.string().optional().describe('Name of the project context'),
    outputDirectory: z.string().optional().default('.qwickai/reports').describe('Directory to store agent output'),
    streaming: z.boolean().optional().default(false).describe('Enable streaming output'),
    saveOutput: z.boolean().optional().default(true).describe('Save output to file'),
    maxRetries: z.number().min(0).max(5).optional().default(3).describe('Maximum retry attempts'),
    timeout: z.number().positive().optional().describe('Execution timeout in milliseconds')
});
export const CostEstimatorInputSchema = z.object({
    sessionId: z.string().uuid().describe('Session identifier for tracking'),
    agentName: z.string().min(1).describe('Name of the agent'),
    prompt: z.string().min(1).describe('The prompt to estimate cost for')
});
export function validateProjectValidatorInput(input) {
    return ProjectValidatorInputSchema.parse(input);
}
export function validateProjectAnalyzerInput(input) {
    return ProjectAnalyzerInputSchema.parse(input);
}
export function validateContextAnalyzerInput(input) {
    return ContextAnalyzerInputSchema.parse(input);
}
export function validateAgentListerInput(input) {
    return AgentListerInputSchema.parse(input);
}
export function validateConfigValidatorInput(input) {
    return ConfigValidatorInputSchema.parse(input);
}
export function validatePipelineOrchestratorInput(input) {
    return PipelineOrchestratorInputSchema.parse(input);
}
export function validateAgentExecutorInput(input) {
    return AgentExecutorInputSchema.parse(input);
}
export function validateCostEstimatorInput(input) {
    return CostEstimatorInputSchema.parse(input);
}
//# sourceMappingURL=mcp-tool-contracts.js.map